import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=1d41b753&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=1d41b753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41b753",
  null
  
)

export default component.exports